import PropTypes from 'prop-types';

export const JournalType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    publisher: PropTypes.string.isRequired,
    founder: PropTypes.string.isRequired,
    issn_print: PropTypes.string.isRequired,
    issn_online: PropTypes.string.isRequired,
    issued_since_month: PropTypes.number.isRequired,
    issued_since_year: PropTypes.number.isRequired,
    is_active: PropTypes.number,
});



// WEBPACK FOOTER //
// ./src/types/journal.js